



























































import Vue from "vue";
import Navigation from "@/components/Navigation.vue";
import { Component } from "vue-property-decorator";

@Component({
  components: { Navigation }
})
export default class App extends Vue {
  private backgroundWidth = 500;
  private backgroundHeight = 500;

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.performBackgroundUpdate();
  }

  private performBackgroundUpdate() {
    this.updateSize();
    this.$nextTick(() => this.drawBackground());
  }

  private updateSize() {
    const mainCanvas = document.getElementById("primary-container");
    if (mainCanvas) {
      const boundingRect = mainCanvas.getBoundingClientRect();
      this.backgroundHeight = boundingRect.height;
      this.backgroundWidth = boundingRect.width;
    }
  }

  private drawBackground() {
    const backgroundCanvas = document.getElementById(
      "backgroundImage"
    ) as HTMLCanvasElement;
    const ctx = backgroundCanvas.getContext("2d");
    if (!ctx) return;
    const w = this.backgroundWidth;
    const h = this.backgroundHeight;
    ctx.clearRect(0, 0, w, h);
    ctx.beginPath();
    ctx.moveTo(0, h * 0.85);
    ctx.quadraticCurveTo(w / 1.85, h, w, h / 2);
    ctx.lineTo(w, h);
    ctx.lineTo(0, h);
    ctx.fillStyle = "#282f35";
    ctx.strokeStyle = "#282F35";
    ctx.fill();
    ctx.closePath();
    ctx.stroke();
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }

  onResize() {
    this.performBackgroundUpdate();
  }
}
